'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = PillItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _link = require('../link');

require('./pill.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Pill Item Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function PillItem(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$href = props.href,
        href = _props$href === undefined ? '' : _props$href;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-pill-item': true
    }, '' + className, className));

    return (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link.Link, {
        className: classNames,
        id: id,
        href: href
    }, void 0, props.children));
}
//# sourceMappingURL=PillItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/pill/PillItem.js
// module id = 593
// module chunks = 0